import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'dome',
  size: 24,
  node: [
    ['path', { d: 'M10 21v-3a2 2 0 014 0v3', key: '109363' }],
    ['path', { d: 'M12 2v2', key: 'tus03m' }],
    ['path', { d: 'M18 12v9', key: 'igdtv6' }],
    [
      'path',
      { d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a1 1 0 011-1h18a1 1 0 011 1z', key: 'ggamol' },
    ],
    ['path', { d: 'M4 12a8 8 0 0116 0', key: 'ug8bwn' }],
    ['path', { d: 'M6 12v9', key: '9e33v1' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Dome
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjF2LTNhMiAyIDAgMDE0IDB2MyIgLz4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xOCAxMnY5IiAvPgogIDxwYXRoIGQ9Ik0yMiAxOWEyIDIgMCAwMS0yIDJINGEyIDIgMCAwMS0yLTJ2LTZhMSAxIDAgMDExLTFoMThhMSAxIDAgMDExIDF6IiAvPgogIDxwYXRoIGQ9Ik00IDEyYTggOCAwIDAxMTYgMCIgLz4KICA8cGF0aCBkPSJNNiAxMnY5IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/dome
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dome = createLucideIcon(__iconData);

export default Dome;
